/** A tab row's overflow cue (0.91.0, shared since 1.0.0-rc.9): which sides have tabs out of view, and how far an arrow scrolls. */

/** Sides of a horizontally scrolling row that hide content; a pixel of slack absorbs sub-pixel rounding. */
export function overflowSides(scrollLeft: number, clientWidth: number, scrollWidth: number): { left: boolean; right: boolean } {
  if (scrollWidth - clientWidth <= 1) return { left: false, right: false };
  return { left: scrollLeft > 1, right: scrollLeft + clientWidth < scrollWidth - 1 };
}

/** An arrow click scrolls by about one view of tabs, keeping a little of the previous view for context. */
export function scrollStep(clientWidth: number): number {
  return Math.max(80, Math.round(clientWidth * 0.8));
}

/**
 * How far to scroll a row so a tab is fully in view, clear of the fade and arrow on that side.
 * Positions are viewport coordinates (getBoundingClientRect); 0 means the tab is already in view.
 */
export function revealDelta(row: { left: number; right: number }, tab: { left: number; right: number }, pad: number): number {
  if (tab.left < row.left + pad) return tab.left - row.left - pad;
  if (tab.right > row.right - pad) return tab.right - row.right + pad;
  return 0;
}
